import React from "react";
import { Provider } from "react-redux";
import { useComponentStore } from "@wss/store";
import Store from "~/common/Store";
import { defaultUserObject } from "~/common/Store/rootReducer";
import { Product } from "~/common/Store/models/ProductListing";
import ProductBoxes from "../ProductBoxes";
import Chrome from "../Toolbar/Chrome";
import useIsMounted from "~/common/useIsMounted";
import { FacetNavigation } from "../Sidebar/Filters";
import Pagination from "~/common/Store/models/Pagination";
import { CompareProductsState } from "../compareProductStore";
import ChromeStoreContextProvider from "../Toolbar/ChromeStoreContextProvider";
import { ChromeBarState } from "../Toolbar/useChromeBarComponentStore";

interface ChromeAndProductsData {
  readonly title: string;
  readonly displayProducts: Product[];
  readonly pagination: Pagination;
  readonly facetNavigation: FacetNavigation;
}

export default function ChromeAndProducts({
  title,
  displayProducts,
  pagination,
  facetNavigation,
}: ChromeAndProductsData) {
  const mounted = useIsMounted();
  const compareProductsStore = useComponentStore<CompareProductsState>(() => ({
    active: false,
    items: [],
  }));

  const chromeBarStore = useComponentStore<ChromeBarState>(() => ({
    view: "grid",
  }));

  if (!displayProducts || displayProducts.length === 0) {
    return <></>;
  }
  return (
    <ChromeStoreContextProvider chromeBarStore={chromeBarStore}>
      <Chrome
        title={title}
        hasHeaderData={false}
        displayFilters={false}
        pagination={pagination}
        displayTopper={false}
        chromeBarStore={chromeBarStore}
        compareProductsStore={compareProductsStore}
        toggleShowMobileFilter={() => undefined}
        pageName=""
        pageUrl=""
        toggleShowMobileSortFilter={() => undefined}
        displaySortByDropdown={false}
      />
      <Provider store={Store}>
        <ProductBoxes
          items={displayProducts}
          chromeBarStore={chromeBarStore}
          pagination={undefined}
          filtersSelected={false}
          user={defaultUserObject}
          mounted={mounted}
          facetNavigation={facetNavigation}
        />
      </Provider>
    </ChromeStoreContextProvider>
  );
}
